// @flow
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { Checkbox, FullButton } from '../../components/common';
import I18n from '../../lib/i18n';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import type { CustomerOptionCommercialType } from '../../modules/Customer';

type Props = {
  navigation: NavigationScreenProp<NavigationRoute>,
  customerOptionCommercial: CustomerOptionCommercialType,
  confirmCustomerOptionCommercial: CustomerOptionCommercialType => null,
  isLoading: boolean,
};

type State = CustomerOptionCommercialType;

class ChangeMarketingApproval extends Component<Props, State> {
  styles = getStyles();

  constructor(props: Props) {
    super(props);
    const { optionInternalCommercial, optionExternalCommercial } = props.customerOptionCommercial;
    this.state = { optionInternalCommercial, optionExternalCommercial };
  }

  onConfirm = () => {
    const { optionExternalCommercial, optionInternalCommercial } = this.state;
    this.props.confirmCustomerOptionCommercial({ optionExternalCommercial, optionInternalCommercial });
  };

  toggleOptionInternalCommercial = () =>
    this.setState({ optionInternalCommercial: !this.state.optionInternalCommercial });

  toggleOptionExternalCommercial = () =>
    this.setState({ optionExternalCommercial: !this.state.optionExternalCommercial });

  render() {
    const styles = this.styles;

    return (
      <View style={styles.container}>
        <View style={styles.checkboxesContainer}>
          <Checkbox
            style={styles.checkbox}
            labelStyle={styles.termsText}
            onPress={this.toggleOptionInternalCommercial}
            isChecked={this.state.optionInternalCommercial}
            text={I18n.t('SignUp.CreateAccount.optionInternalCommercial')}
            lightColors
          />
          <Checkbox
            style={styles.checkbox}
            labelStyle={styles.termsText}
            onPress={this.toggleOptionExternalCommercial}
            isChecked={this.state.optionExternalCommercial}
            text={I18n.t('SignUp.CreateAccount.optionExternalCommercial')}
            lightColors
          />
        </View>
        <View style={styles.bottomContainer}>
          <FullButton
            isLoading={this.props.isLoading}
            style={styles.fullbutton}
            onPress={this.onConfirm}
            text={I18n.t('confirm')}
          />
        </View>
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'space-between',
    },
    checkboxesContainer: {
      marginVertical: 17,
      marginHorizontal: 17,
    },
    checkbox: {
      marginBottom: 10,
    },
    bottomContainer: {
      marginVertical: 17,
    },
    fullbutton: {
      marginHorizontal: 17,
    },
    termsText: {
      fontSize: 16,
      lineHeight: 15,
      textAlign: 'left',
    },
  });

export default ChangeMarketingApproval;
